export const DEBOUNCE = function(fn, time) {
    let timeout;

    return function () {
        const functionCall = () => fn.apply(this, arguments);

        clearTimeout(timeout);
        timeout = setTimeout(functionCall, time);
    }
}


// WEBPACK FOOTER //
// ./src/mixins/helper.js